import { WorkTimeKeep } from "../../models/WorkTimeKeep";
import { WorkTimeView } from "../../models/WorkTimeView";
import { WorkView } from "../../models/WorkView";
import { APIClient } from "../api";
export interface Validate {
    name: string;
    validateMessage: string;
    valid: boolean;
}
export default class WorkService extends APIClient {
    validateRules(work: WorkView, setValidations: any) {
        var validationsChecks: Validate[] = [];

        if (!(work.description.length > 0)) {
            validationsChecks.push({
                name: 'description',
                validateMessage: 'Deve possuir descrição.',
                valid: false
            });
        }

        // if (!(work.idUser > 0)) {
        //     validationsChecks.push({
        //         name: 'idUser',
        //         validateMessage: 'Deve possuir atendente.',
        //         valid: false
        //     });
        // }

        if (!(work.idWorkType > 0)) {
            validationsChecks.push({
                name: 'idWorkType',
                validateMessage: 'Deve possuir tipo.',
                valid: false
            });
        }

        if (!(work.idWorkTeam > 0)) {
            validationsChecks.push({
                name: 'idWorkTeam',
                validateMessage: 'Deve possuir equipe.',
                valid: false
            });
        }

        if (!(work.idWorkGroupType > 0)) {
            validationsChecks.push({
                name: 'idWorkGroupType',
                validateMessage: 'Deve possuir grupo de tipo.',
                valid: false
            });
        }

        if (!(work.subject.length > 0)) {
            validationsChecks.push({
                name: 'subject',
                validateMessage: 'Deve possuir assunto.',
                valid: false
            });
        }

        setValidations(validationsChecks);
        return validationsChecks.length == 0;
    }

    constructor(props: any) {
        super(props);
    }

    async GetById(workId: number) {
        const url = `${this.endpoint}/Work/${workId}`;

        return this.api({
            method: 'get',
            url
        });
    }

    async GetAllWork() {
        const url = this.endpoint + `/Work/GetWorkView`;

        return this.api({
            method: 'get',
            url
        });
    }

    async getWorks(SolicitationId: number) {
        const url = this.endpoint + `/Work?$filter=IdSolicitation eq ${SolicitationId}`;

        return this.api({
            method: 'get',
            url
        });
    }

    async getWorkTimes(idWork: number) {
        const url = this.endpoint + `/Work/WorkTimeView/${idWork}`;

        return (await this.api({
            method: 'get',
            url
        })).data;
    }

    async getWorkViews(solicitationId: number) {
        const url = this.endpoint + `/Work/GetWorkView?$filter=IdSolicitation eq ${solicitationId}`;

        return this.api({
            method: 'get',
            url
        });
    }

    async getWorkViewbySolicitation(solicitationId: number) {
        const url = this.endpoint + `/Work/GetWorkViewbySolicitation?solicitationId=${solicitationId}`;

        return (await this.api({
            method: 'get',
            url
        })).data;
    }

    async editWorkTime(work: WorkTimeView) {
        const url = this.endpoint + '/Work/EditWorkTime';

        return await this.api({
            method: 'put',
            url,
            headers: { "Content-Type": "application/json" },
            params: null,
            data: work
        });
    }

    async updateWork(work: WorkView) {
        const url = this.endpoint + '/Work';
        //  const url = `${this.endpointApiCore}/api/Work/UpdateWork`;

        return await this.api({
            method: 'put',
            // method: 'post',
            url,
            headers: { "Content-Type": "application/json" },
            params: null,
            data: work
        });
    }

    async updateWorkNew(work: WorkView) {
        // const url = this.endpoint + '/Work';
         const url = `${this.endpointApiCore}/api/Work/UpdateWork`;

        return await this.api({
            // method: 'put',
            method: 'post',
            url,
            headers: { "Content-Type": "application/json" },
            params: null,
            data: work
        });
    }

    async transferWork(work: any) {
        const url = this.endpoint + '/Work/TransferWorkV2';
        // const url = `${this.endpointApiCore}/api/Work/TransferWork`;
        // const url = this.endpoint + '/Work'; 

        return await this.api({
            method: 'put',
            url,
            headers: { "Content-Type": "application/json" },
            params: null,
            data: work
        });
    }

    async approvalFlow(approvedWorks: any) {
        const url = `${this.endpoint}/Work/ApprovalFlow`;
        // const url = `${this.endpointApiCore}/api/Work/ApprovalFlow`;

        return await this.api({
            method: 'put',
            url,
            headers: { "Content-Type": "application/json" },
            params: null,
            data: approvedWorks
        });
    }

    async getApprovalList(businessAreaId: number, idFlowApproval?: number) {
        const url = `${this.endpoint}/Work/GetApprovalList/${businessAreaId}?ApprovalFlowId=${idFlowApproval}`;

        return this.api({
            method: 'get',
            url
        });
    }

    async getApprovalListByProcessId(ProcessId: number) {
        const url = `${this.endpoint}/Work/GetApprovalListByProcessId/${ProcessId}`;

        return this.api({
            method: 'get',
            url
        });
    }
    
    async GetApprovalListByUserId(UserId: number) {
        const url = `${this.endpoint}/Work/GetApprovalListByUserId/${UserId}`;

        return this.api({
            method: 'get',
            url
        });
    }

    async postWork(work: WorkView) {
        const url = `${this.endpoint}/Work/NewWork`;
        // const url = `${this.endpointApiCore}/api/Work/NewWork`;

        return await this.api({
            method: 'post',
            url,
            headers: { "Content-Type": "application/json" },
            params: null,
            data: work
        });
    }

    async SetTimeKeep(workTimeKeep: WorkTimeKeep) {
        const url = `${this.endpoint}/Work/SetTimeKeep`;

        return await this.api({
            method: 'post',
            url,
            headers: { "Content-Type": "application/json" },
            params: null,
            data: workTimeKeep
        });
    }

    async GetTimeKeep(idWork: number) {
        const url = `${this.endpoint}/Work/GetTimeKeep`;

        return await this.api({
            method: 'post',
            url,
            headers: { "Content-Type": "application/json" },
            params: null,
            data: idWork
        });
    }

    async CreateWorkProcessWorkTypeList(workTypeProcessList: any) {
        const url = `${this.endpoint}/Work/CreateWorkProcessWorkTypeList`;

        return await this.api({
            method: 'post',
            url,
            headers: { "Content-Type": "application/json" },
            params: null,
            data: workTypeProcessList
        });
    }
}